/*
  Swannies Golf – Product Accordion JS
  File: assets/swannies-accordion.js
*/

(function () {
  'use strict';

  function SwanniesAccordion(container) {
    this.container = container;
    this.triggers = Array.from(container.querySelectorAll('.swannies-accordion__trigger'));
    this.init();
  }

  SwanniesAccordion.prototype.init = function () {
    var self = this;
    
    this.triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        self.toggleItem(this);
      });
    });
  };

  SwanniesAccordion.prototype.toggleItem = function (trigger) {
    var item = trigger.closest('.swannies-accordion__item');
    var panel = item.querySelector('.swannies-accordion__panel');
    var content = item.querySelector('.swannies-accordion__content');
    var isActive = item.classList.contains('active');
    
    // Close all items
    this.closeAll();
    
    // Open clicked item if it wasn't active
    if (!isActive) {
      item.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.style.maxHeight = content.scrollHeight + 'px';
      }
    }
  };

  SwanniesAccordion.prototype.closeAll = function () {
    var items = this.container.querySelectorAll('.swannies-accordion__item');
    
    items.forEach(function(item) {
      var trigger = item.querySelector('.swannies-accordion__trigger');
      var panel = item.querySelector('.swannies-accordion__panel');
      
      item.classList.remove('active');
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.style.maxHeight = null;
      }
    });
  };

  // Initialize all accordions on page load
  document.addEventListener('DOMContentLoaded', function() {
    var accordions = document.querySelectorAll('.swannies-accordion');
    
    accordions.forEach(function(accordion) {
      new SwanniesAccordion(accordion);
    });
  });

  // Expose to window for dynamic initialization
  window.SwanniesAccordion = SwanniesAccordion;

})();